/**
 * Whether this document is rendered inside a frame (an embed in Rock, or
 * any other host page). App-shell prompts and full-screen flows stay out
 * of frames. A cross-origin parent throws on access, which also means framed.
 *
 * @returns {boolean}
 */
export function isFramed() {
  try {
    return window.self !== window.top
  } catch {
    return true
  }
}

export default isFramed
